import Overview from './overview.vue';
import Full from '@/rebuild/materials/shared/finance_data/FullIndex.vue';
import MobOverview from '@/rebuild/materials/shared/finance_data/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/finance_data/MobFull.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
